import React from "react";
// import { Document, Page } from "react-pdf";

// import samplePDF from "./test.pdf";

function AppointmentExcel() {
  return (
    <p>EXCEL FILE</p>
    // <Document file={sampleExcel}>
    //    <p>EXCEL FILE</p>
    //   <Page pageNumber={1} />
    // </Document>
  );
}

export default AppointmentExcel;
